import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { Utils } from '@ortho-next/nextray-core';
import { AnatomicalSideLabelPipe, BaseMaApTableComponent } from '../../shared';


/**
* Table of correction measures for AP image.
*/
@Component({
	selector: 'ma-ap-recap',
	templateUrl: './ma-ap-recap.component.html',
	imports: [
		NgbCollapseModule,
		AnatomicalSideLabelPipe
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class MaApRecapComponent extends BaseMaApTableComponent {

	isCollapsed = true;

	/**
	* Check if MAD value is valid.
	*/
	get isValidMAD(): boolean {
		return !this.eocMeasures?.eoc_ap_MAD || Utils.isPaleyAngleValid(this.eocMeasures.eoc_ap_MAD, this.apAngles.MAD);
	}

	/**
	* Check if MNSA value is valid.
	*/
	get isValidMNSA(): boolean {
		return !this.eocMeasures?.eoc_ap_MNSA || Utils.isPaleyAngleValid(this.eocMeasures.eoc_ap_MNSA, this.apAngles.MNSA);
	}

	/**
	* Check if LPFA value is valid.
	*/
	get isValidLPFA(): boolean {
		return !this.eocMeasures?.eoc_ap_LPFA || Utils.isPaleyAngleValid(this.eocMeasures.eoc_ap_LPFA, this.apAngles.mLPFA);
	}

	/**
	* Check if MPFA value is valid.
	*/
	get isValidMPFA(): boolean {
		return !this.eocMeasures?.eoc_ap_MPFA || Utils.isPaleyAngleValid(this.eocMeasures.eoc_ap_MPFA, this.apAngles.MPFA);
	}

	/**
	* Check if MLDFA value is valid.
	*/
	get isValidMLDFA(): boolean {
		return !this.eocMeasures?.eoc_ap_mLDFA || Utils.isPaleyAngleValid(this.eocMeasures.eoc_ap_mLDFA, this.apAngles.mLDFA);
	}

	/**
	* Check if JLCA value is valid.
	*/
	get isValidJLCA(): boolean {
		return !this.eocMeasures?.eoc_ap_JLCA || Utils.isPaleyAngleValid(this.eocMeasures.eoc_ap_JLCA, this.apAngles.JLCA);
	}

	/**
	* Check if Knee Translation value is valid.
	*/
	get isValidKneeTransl(): boolean {
		return !this.eocMeasures?.eoc_ap_kneeTranslation || Utils.isPaleyAngleValid(this.eocMeasures.eoc_ap_kneeTranslation, this.apAngles.KneeTransl);
	}

	/**
	* Check if MPTA value is valid.
	*/
	get isValidMPTA(): boolean {
		return !this.eocMeasures?.eoc_ap_MPTA || Utils.isPaleyAngleValid(this.eocMeasures.eoc_ap_MPTA, this.apAngles.MPTA);
	}

	/**
	* Check if LDTA value is valid.
	*/
	get isValidLDTA(): boolean {
		return !this.eocMeasures?.eoc_ap_LDTA || Utils.isPaleyAngleValid(this.eocMeasures.eoc_ap_LDTA, this.apAngles.LDTA);
	}

	/**
	* Check if a measure is out of range.
	*/
	get isMeasureOutOfRange(): boolean {
		return !this.isValidMAD || !this.isValidMNSA || !this.isValidLPFA || !this.isValidMPFA || !this.isValidMLDFA || !this.isValidJLCA || !this.isValidKneeTransl || !this.isValidMPTA || !this.isValidLDTA;
	}

}
